// 路由分析统计插件
// 迁移自 main.js : router.afterEach（51.la 统计脚本）

export default function ({ app }) {
  if (process.client) {
    app.router.afterEach((to, from) => {
      setTimeout(() => {
        // 每次执行前，先移除上次插入的代码
        document.getElementById('51_la') && document.getElementById('51_la').remove()
        var hm = document.createElement('script')
        hm.src = 'https://js.users.51.la/21492603.js'
        hm.id = '51_la'
        var s = document.getElementsByTagName('script')[0]
        s.parentNode.insertBefore(hm, s)
      }, 0)
    })
  }
}
